// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contact-column-details{align-items:center;display:flex;margin:11px 0 15px 0}.contact-column-details__link{margin-right:5px}.contact-column-details__link:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
